import {jsx} from 'panel';

import {Directions} from 'common/components/drop-menu/types';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {pluralize} from 'common/util/string';

import {NumberOfStepsDropdownEl} from './number-of-steps-dropdown';

export function NumberOfStepsSubitem({
  forward,
  reverse,
  menuChangeHandler,
  updateStepsValueHandler,
}: {
  forward: number;
  reverse: number;
  menuChangeHandler: (ev: CustomEvent) => void;
  updateStepsValueHandler: (ev: CustomEvent) => void;
}) {
  const label = `${reverse} ${pluralize(`Step`, reverse)} before, ${forward} ${pluralize(`Step`, forward)} after`;
  return (
    <SelectEl
      attrs={{
        theme: SelectTheme.Tertiary,
        'always-show-caret': true,
        'selected-option': label,
        'menu-alignment': Directions.Down,
      }}
      on={{menuChange: menuChangeHandler}}
    >
      <NumberOfStepsDropdownEl
        attrs={{
          'committed-before-steps': reverse,
          'committed-after-steps': forward,
          slot: `body`,
        }}
        on={{updateStepsValue: updateStepsValueHandler}}
      />
    </SelectEl>
  );
}
